import { mapInputRequiredToGateCard } from './mapInputRequiredToGateCard.js';

/**
 * Return the normalized gate card ONLY when the current `hitlRequest` is a
 * document-pick gate (`mode: 'pick'`), otherwise `null`.
 *
 * Lets the composer decide whether an incoming file upload should resolve the
 * active pick gate (via `file_uuid`) instead of becoming a normal agent
 * attachment. Any other gate kind — or no gate — leaves uploads untouched.
 *
 * @param {object|null|undefined} hitlRequest  The current `hitlRequest` slot.
 * @returns {{ interactionId: string, gate: string|undefined, render: object } | null}
 */
export const pickGateFromRequest = (hitlRequest) => {
  const card = mapInputRequiredToGateCard(hitlRequest);
  return card && card.mode === 'pick' ? card : null;
};

export default pickGateFromRequest;
